import '../resources/css/accordion.css';
import parse from 'html-react-parser';
import classnames from 'classnames';
import { useState } from 'react';

export default function Accordion({ title, items }) {

	const [activeItem, setActiveItem] = useState(0);

	const handleClick = (index) => {
		setActiveItem(index);
	}

	const renderedParts = (items || []).map((item, index) => {

		const parsedText = parse(item.text || '');

		const headerClasses = classnames('accordion-header', {
			'accordion-header-pink': item.color === 'pink',
			'accordion-header-blue': item.color === 'blue',
			'accordion-header-green': item.color === 'green',
		});

		const contentClasses = classnames('accordion-content', {
			'accordion-content-pink': item.color === 'pink',
			'accordion-content-blue': item.color === 'blue',
			'accordion-content-green': item.color === 'green',
			'accordion-active-content': activeItem === index
		});

		return <div key={index} className="accordion-item">
			<div className={headerClasses} onClick={() => { handleClick(index) } } >
				<h3>
					<i className={item.icon}></i>
					{item.title}
				</h3>
			</div>
			<div className={contentClasses}>{parsedText}</div>
		</div>
	});

	return (
		<div className="accordion">
			<p className="bold title-h5 color-purple">{title}</p>
			<div>
				{renderedParts}
			</div>
		</div>
	);
}